import {IPresenter} from "@/rawdogjs/src/interfaces/IPresenter";
import {CleaningCalculatorView} from "./cleaningCalculatorView";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";
import {Router} from "@/rawdogjs/src/router";
import {CleaningQuoteCalculator} from "./cleaningCalculator";

export class CleaningCalculatorPresenter implements IPresenter {

    public _view: CleaningCalculatorView;
    private dependencyContainer: ParcelDependencyContainer;
    private _router: Router;

    private bedrooms: number = 2;
    private bathrooms: number = 1;

    constructor(view: CleaningCalculatorView, router: Router, dependencyContainer: ParcelDependencyContainer) {
        this._router = router;
        this._view = view;
        this.dependencyContainer = dependencyContainer;
    }

    async initialize() {
        this._view.setBedrooms(this.bedrooms);
        this._view.setBathrooms(this.bathrooms);

        this.calculate();

        this._view.onBedroomsChange((value) => {
            this.bedrooms = value;
            this.calculate();
        });

        this._view.onBathroomsChange((value) => {
            this.bathrooms = value;
            this.calculate();
        });

        this._view.onContinue(() => {
            this._router.navigate(`/#/drywallio/capture-email?bedrooms=${this.bedrooms}&bathrooms=${this.bathrooms}`);
        });
    }

    private calculate(): void {
        const result = CleaningQuoteCalculator.calculate({
            bedrooms: this.bedrooms,
            bathrooms: this.bathrooms,
        });
        this._view.setResult(result);
    }

    inject() {
    }

}
